import React from 'react';
import PropTypes from 'prop-types';
import styles from './CheckBox.scss';

const CheckBox = ({
					  name,
					  label = '',
					  checked = false,
					  onChange,
					  required,
					  error = '',
					  layout = 'Default',
					  disabled,
					  id,
				  }) => {

	let labelClassInner = styles[layout] || styles.Default;
	if (disabled) labelClassInner += ` ${styles.disabled}`;

	const handleChange = (e) => {
		if (onChange) {
			onChange(e.target.checked);
		}
	};

	return (
	  <div className={styles.container}>
		  <label className={labelClassInner}>
			  <input
				type="checkbox"
				name={name}
				checked={checked}
				required={required}
				disabled={disabled}
				id={id}
				onChange={handleChange}
				className={styles.input}
			  />
			  <span className={`${styles.box} ${checked ? styles.checked : ''}`} aria-hidden="true"/>
			  {label &&
				<span className={styles.text} dangerouslySetInnerHTML={{__html: label}}/>
			  }
		  </label>

		  {error !== '' && (
			<div
			  className={styles.error}
			  dangerouslySetInnerHTML={{__html: error}}
			/>
		  )}
	  </div>
	);
};

CheckBox.displayName = 'CheckBox';

CheckBox.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	required: PropTypes.bool,
	error: PropTypes.string,
	layout: PropTypes.oneOf(['Default']),
	disabled: PropTypes.bool,
	id: PropTypes.string,
};

export default CheckBox;
